import React from 'react';
import PropTypes from 'prop-types';
import { BodySmall } from '@styled';
import { formatMoney } from '@general/helpers/currency.helpers';

const CartSummaryDiscountDisplay = ({ amount, label, locale }) => {
    return (
        <div className="flex justify-between mb-1rem">
            <BodySmall className="text-admiral">{label}</BodySmall>
            <BodySmall className="text-admiral">-{formatMoney(amount, locale)}</BodySmall>
        </div>
    );
};

CartSummaryDiscountDisplay.propTypes = {
    amount: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
};

export default CartSummaryDiscountDisplay;
